import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXcodeComponent } from './simple-icons-xcode.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXcodeComponent ],
    exports:      [ SimpleIconsXcodeComponent ],
    bootstrap:    []
})
export class SimpleIconsXcodeModule {}
